import { useLazyQuery } from "@apollo/client";
import adsAboutToExpireQuery from "../query/adsAboutToExpire.graphql";

const useLazyAdsAboutToExpire = () => {
  return useLazyQuery(adsAboutToExpireQuery);
};

export default useLazyAdsAboutToExpire;
